/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import isNumber from 'lodash/isNumber';
import isObject from 'lodash/isObject';
import isObjectLike from 'lodash/isObjectLike';

/**
 * Komunikátor analytických dat pro Ki-Wi Server.
 */
export default class CommunicatorAnalytics {
  // TODO #389: Nyní vlastně potřebujeme jen boolean parsovat, ale není jasné
  // bez specifikace, co je příznakem pro zapnutí sbírání analytiky.
  // Proto ponecháme původní kód a příznak stanovíme tak, že výsledek není
  // undefined.
  /**
   * Zpracuje periodu zasílání analytických dat.
   * @param {{ apikey: string, frequency: number, type: 'server' } | undefined} json Část odpovědi na obsah zařízení s nastavením analýzy.
   * @returns {number | undefined} Doba, kterou má trvat analytická skupina. [ms]
   */
  static parse(json) {
    if (
      isObject(json) &&
      // TODO #555: Nejde použít jen isObjectLike, protože chybí TS typeguard is object.
      isObjectLike(json) &&
      json.type === 'server' &&
      isNumber(json.frequency) &&
      json.frequency > 0
    ) {
      return json.frequency * 1000;
    }
    return undefined;
  }
}
